// Improved Cart Quantity Selectors JavaScript

(function () {
  // Show quantity error message
  function showQuantityError(container, message) {
    container.classList.add('error');

    // Remove existing error message
    const existingError = container.querySelector('.quantity-error-message');
    if (existingError) {
      existingError.remove();
    }

    // Create and show error message
    const errorDiv = document.createElement('div');
    errorDiv.className = 'quantity-error-message';
    errorDiv.textContent = message;
    errorDiv.style.cssText = `
      position: absolute;
      top: -30px;
      left: 50%;
      transform: translateX(-50%);
      background: #dc2626;
      color: white;
      padding: 4px 8px;
      border-radius: 4px;
      font-size: 11px;
      font-weight: 500;
      white-space: nowrap;
      z-index: 1000;
      animation: fadeInDown 0.3s ease;
    `;

    container.style.position = 'relative';
    container.appendChild(errorDiv);

    // Remove error after 3 seconds
    setTimeout(() => {
      container.classList.remove('error');
      if (errorDiv && errorDiv.parentNode) {
        errorDiv.remove();
      }
    }, 3000);

    // Add vibration if available
    if ('vibrate' in navigator) {
      navigator.vibrate([100, 50, 100]);
    }
  }

  // Check inventory limits for product page quantity selectors
  function checkInventoryLimits(input, newValue) {
    const inventoryQuantity = parseInt(input.getAttribute('data-inventory-quantity'));
    const inventoryPolicy = input.getAttribute('data-inventory-policy');
    const maxAllowed = parseInt(input.getAttribute('max'));

    // If inventory is managed and policy is not 'continue', enforce limits
    if (inventoryQuantity !== null && inventoryPolicy !== 'continue') {
      if (newValue > inventoryQuantity) {
        return {
          valid: false,
          message: `Only ${inventoryQuantity} available in stock`
        };
      }
    }

    // Check against max attribute
    if (maxAllowed && newValue > maxAllowed) {
      return {
        valid: false,
        message: `Maximum quantity is ${maxAllowed}`
      };
    }

    return { valid: true };
  }

  // Enhanced quantity input handling
  function initQuantityInputs() {
    const cartDrawer = document.querySelector('#CartDrawer');
    const cartItems = document.querySelector('.cart-items');
    if (!cartDrawer && !cartItems) return;

    const containers = [cartDrawer, cartItems].filter(Boolean);

    containers.forEach(container => {
      const quantityInputs = container.querySelectorAll('.quantity__input');
      const quantityButtons = container.querySelectorAll('.quantity__button');

      // Add improved input handling
      quantityInputs.forEach(input => {
        // Only add listeners if not already present
        if (input.dataset.improvedQuantityInit) return;
        input.dataset.improvedQuantityInit = 'true';

        const quantityContainer = input.closest('.quantity');
        const minusButton = quantityContainer.querySelector('button[name="minus"]');
        const plusButton = quantityContainer.querySelector('button[name="plus"]');

        // Update button states based on input value
        function updateButtonStates() {
          const value = parseInt(input.value) || 0;
          const min = parseInt(input.getAttribute('min')) || 1;
          const max = parseInt(input.getAttribute('max')) || 999;

          if (minusButton) {
            minusButton.disabled = value <= min;
          }
          if (plusButton) {
            plusButton.disabled = value >= max;
          }
        }

        // Initial state
        updateButtonStates();

        // Update on input change
        input.addEventListener('input', function () {
          updateButtonStates();

          // Add visual feedback
          quantityContainer.classList.remove('error', 'success');
          quantityContainer.classList.add('loading');

          // Clear loading state after a short delay
          setTimeout(() => {
            quantityContainer.classList.remove('loading');
            quantityContainer.classList.add('success');

            // Remove success state after animation
            setTimeout(() => {
              quantityContainer.classList.remove('success');
            }, 1500);
          }, 300);
        });

        // Handle keyboard input validation
        input.addEventListener('keydown', function (e) {
          if ([8, 9, 27, 13, 46].indexOf(e.keyCode) !== -1 ||
            (e.keyCode === 65 && e.ctrlKey === true) ||
            (e.keyCode === 67 && e.ctrlKey === true) ||
            (e.keyCode === 86 && e.ctrlKey === true) ||
            (e.keyCode === 88 && e.ctrlKey === true) ||
            (e.keyCode >= 35 && e.keyCode <= 39)) {
            return;
          }
          if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
          }
        });

        input.addEventListener('blur', function () {
          const value = parseInt(this.value) || 0;
          const min = parseInt(this.getAttribute('min')) || 1;

          if (value < min) {
            this.value = min;
            showQuantityError(quantityContainer, `Minimum quantity is ${min}`);
          } else {
            const validation = checkInventoryLimits(this, value);
            if (!validation.valid) {
              const max = parseInt(this.getAttribute('max')) || value;
              this.value = max;
              showQuantityError(quantityContainer, validation.message);
            }
          }

          updateButtonStates();
        });

        input.addEventListener('focus', function () {
          setTimeout(() => this.select(), 0);
        });
      });

      // Enhanced button handling with inventory checking
      quantityButtons.forEach(button => {
        if (button.dataset.improvedQuantityInit) return;
        button.dataset.improvedQuantityInit = 'true';

        button.addEventListener('click', function (e) {
          if (this.disabled) return;

          const quantityContainer = this.closest('.quantity');
          const input = quantityContainer.querySelector('.quantity__input');
          const isPlus = this.getAttribute('name') === 'plus';

          if (isPlus) {
            const currentValue = parseInt(input.value) || 0;
            const newValue = currentValue + 1;

            const validation = checkInventoryLimits(input, newValue);
            if (!validation.valid) {
              e.preventDefault();
              e.stopPropagation();
              showQuantityError(quantityContainer, validation.message);
              return false;
            }
          }

          this.style.transform = 'scale(0.95)';
          setTimeout(() => {
            this.style.transform = '';
          }, 150);

          if ('vibrate' in navigator) {
            navigator.vibrate(50);
          }

          quantityContainer.classList.add('loading');

          setTimeout(() => {
            quantityContainer.classList.remove('loading');
            quantityContainer.classList.add('success');
            setTimeout(() => {
              quantityContainer.classList.remove('success');
            }, 1000);
          }, 500);
        });

        button.addEventListener('mouseenter', function () {
          if (!this.disabled) {
            this.style.transform = 'scale(1.05)';
          }
        });

        button.addEventListener('mouseleave', function () {
          this.style.transform = '';
        });
      });
    });
  }

  // Initialize
  function setup() {
    initQuantityInputs();

    // Re-initialize when cart is updated (for dynamic content)
    document.addEventListener('cart:updated', function () {
      setTimeout(initQuantityInputs, 100);
    });

    // Re-initialize when cart drawer is opened
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
            setTimeout(initQuantityInputs, 100);
          }
        });
      });

      observer.observe(cartDrawer, {
        attributes: true,
        attributeFilter: ['open']
      });
    }

    // Add smooth transitions when cart items are removed
    document.addEventListener('click', function (e) {
      if (e.target.closest('cart-remove-button')) {
        const cartItem = e.target.closest('.cart-item');
        if (cartItem) {
          cartItem.style.transition = 'all 0.3s ease';
          cartItem.style.opacity = '0.5';
          cartItem.style.transform = 'translateX(-20px)';
        }
      }
    });

    // Keyboard shortcuts
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        const cartDrawer = document.querySelector('#CartDrawer');
        if (cartDrawer && cartDrawer.hasAttribute('open')) {
          const closeButton = cartDrawer.querySelector('.drawer__close');
          if (closeButton) closeButton.click();
        }
      }

      if (document.activeElement && document.activeElement.classList.contains('quantity__input')) {
        const input = document.activeElement;
        const quantityContainer = input.closest('.quantity');

        if (e.key === 'ArrowUp') {
          e.preventDefault();
          const plusButton = quantityContainer.querySelector('button[name="plus"]');
          if (plusButton && !plusButton.disabled) plusButton.click();
        } else if (e.key === 'ArrowDown') {
          e.preventDefault();
          const minusButton = quantityContainer.querySelector('button[name="minus"]');
          if (minusButton && !minusButton.disabled) minusButton.click();
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  // Make functions available globally without triggering DOMContentLoaded
  window.initImprovedQuantitySelectors = function () {
    initQuantityInputs();
  };
})();
